export default {
    "common_accept": {
      "en": "Accept",
      "ja": "受け入れる",
      "zh": "接受",
      "zh_cn": "接受"
    },
    "common_back": {
      "en": "Back",
      "ja": "戻る",
      "zh": "返回",
      "zh_cn": "返回"
    },
    "common_back_2": {
      "en": "BACK",
      "ja": "バック",
      "zh": "返回",
      "zh_cn": "返回"
    },
    "common_back_to_home": {
      "en": "Back to Home",
      "ja": "ホームページに戻る",
      "zh": "返回首頁",
      "zh_cn": "返回首页"
    },
    "common_block": {
      "en": "Block Message",
      "ja": "メッセージをブロックする",
      "zh": "拉黑",
      "zh_cn": "拉黑"
    },
    "common_cancel": {
      "en": "Cancel",
      "ja": "キャンセル",
      "zh": "取消",
      "zh_cn": "取消"
    },
    "common_chip": {
      "en": "Chip",
      "ja": "チップ",
      "zh": "芯片",
      "zh_cn": "芯片"
    },
    "common_claim": {
      "en": "Claim",
      "ja": "受け取る",
      "zh": "領取",
      "zh_cn": "领取"
    },
    "common_claimed": {
      "en": "Claimed",
      "ja": "受け取り済",
      "zh": "已領取",
      "zh_cn": "已领取"
    },
    "common_click_close": {
      "en": "Click to close",
      "ja": "クリックして閉じる",
      "zh": "點擊關閉",
      "zh_cn": "点击关闭"
    },
    "common_close": {
      "en": "Close",
      "ja": "閉じる",
      "zh": "關閉",
      "zh_cn": "关闭"
    },
    "common_confirm": {
      "en": "Confirm",
      "ja": "確認",
      "zh": "確認",
      "zh_cn": "确认"
    },
    "common_continue": {
      "en": "Continue",
      "ja": "続ける",
      "zh": "繼續",
      "zh_cn": "继续"
    },
    "common_copy": {
      "en": "Copy",
      "ja": "コピー",
      "zh": "復製",
      "zh_cn": "复制"
    },
    "common_copy_success": {
      "en": "Copied successfully",
      "ja": "コピーに成功しました",
      "zh": "復製成功",
      "zh_cn": "复制成功"
    },
    "common_correct_invitation_code": {
      "en": "The invitation code is invalid. Please enter the correct invitation code",
      "ja": "招待コードが無効です。正しい招待コードを入力してください",
      "zh": "邀請碼無效。請輸入正確的邀請碼。",
      "zh_cn": "邀请码无效。请输入正确的邀请码。"
    },
    "common_fail": {
      "en": "Fail",
      "ja": "失敗",
      "zh": "失敗",
      "zh_cn": "失败"
    },
    "common_import": {
      "en": "Import",
      "ja": "インポート",
      "zh": "導入",
      "zh_cn": "导入"
    },
    "common_inconvenience_caused": {
      "en": "Dear Yuli Protectors, in order to ensure your better game experience, we are updating maintenance optimization, which may cause you cannot continue playing. We would like to apologize for any inconvenience caused.",
      "ja": "Yuli プロテクターの皆様、より良いゲーム体験を確保するために、メンテナンスの最適化を更新しています。これにより、プレイを続行できなくなる可能性があります。ご不便をおかけして誠に申し訳ございません。",
      "zh": "親愛的玩家，為了保證您更好的遊戲體驗，我們正在更新維護優化，這可能會導致您無法繼續遊戲。對於由此造成的任何不便，我們深表歉意。",
      "zh_cn": "亲爱的玩家，为了保证您更好的游戏体验，我们正在更新维护优化，这可能会导致您无法继续游戏。对于由此造成的任何不便，我们深表歉意。"
    },
    "common_last_page": {
      "en": "Last Page",
      "ja": "前のページ",
      "zh": "上一頁",
      "zh_cn": "上一页"
    },
    "common_log_in_often": {
      "en": "You log in too often~",
      "ja": "頻繁にログインしすぎます~",
      "zh": "你登錄太頻繁了~",
      "zh_cn": "你登录太频繁了~"
    },
    "common_login_authorization": {
      "en": "Login authorization is invalid, please login again",
      "ja": "ログイン認証が無効です。再度ログインしてください。",
      "zh": "登錄授權無效，請重新登錄",
      "zh_cn": "登录授权无效，请重新登录"
    },
    "common_next": {
      "en": "Next",
      "ja": "次へ",
      "zh": "下一步",
      "zh_cn": "下一步"
    },
    "common_next_page": {
      "en": "Next Page",
      "ja": "次のページ",
      "zh": "下一頁",
      "zh_cn": "下一页"
    },
    "common_no_data": {
      "en": "No Data",
      "ja": "データなし",
      "zh": "無數據",
      "zh_cn": "无数据"
    },
    "common_ok": {
      "en": "OK",
      "ja": "OK",
      "zh": "OK",
      "zh_cn": "OK"
    },
    "common_operation_frequent": {
      "en": "Your operation is too frequent",
      "ja": "操作が頻繁すぎる",
      "zh": "您的操作過於頻繁",
      "zh_cn": "您的操作过于频繁"
    },
    "common_previous": {
      "en": "Previous",
      "ja": "前へ",
      "zh": "上一步",
      "zh_cn": "上一步"
    },
    "common_quit": {
      "en": "Quit",
      "ja": "退出する",
      "zh": "退出",
      "zh_cn": "退出"
    },
    "common_quit_now": {
      "en": "Quit Now",
      "ja": "今すぐ退出する",
      "zh": "立即退出",
      "zh_cn": "立即退出"
    },
    "common_rare": {
      "en": "Rare",
      "ja": "レア",
      "zh": "稀有",
      "zh_cn": "稀有"
    },
    "common_read": {
      "en": "Read",
      "ja": "読む",
      "zh": "閱讀",
      "zh_cn": "阅读"
    },
    "common_reject": {
      "en": "Reject",
      "ja": "拒否する",
      "zh": "拒絕",
      "zh_cn": "拒绝"
    },
    "common_request_exception": {
      "en": "Request exception",
      "ja": "リクエスト例外",
      "zh": "請求異常",
      "zh_cn": "请求异常"
    },
    "common_reset": {
      "en": "reset",
      "ja": "リセット",
      "zh": "重置",
      "zh_cn": "重置"
    },
    "common_retry": {
      "en": "Retry",
      "ja": "再試行",
      "zh": "重試",
      "zh_cn": "重试"
    },
    "common_save": {
      "en": "Save",
      "ja": "保存",
      "zh": "保存",
      "zh_cn": "保存"
    },
    "common_save_faild": {
      "en": "Saving faild",
      "ja": "保存に失敗しました",
      "zh": "保存失敗",
      "zh_cn": "保存失败"
    },
    "common_save_success": {
      "en": "Saved successfully",
      "ja": "保存に成功しました",
      "zh": "保存成功",
      "zh_cn": "保存成功"
    },
    "common_share": {
      "en": "Share",
      "ja": "共有",
      "zh": "分享",
      "zh_cn": "分享"
    },
    "common_skip": {
      "en": "Skip",
      "ja": "スキップ",
      "zh": "跳過",
      "zh_cn": "跳过"
    },
    "common_submit": {
      "en": "Submit",
      "ja": "提出する",
      "zh": "提交",
      "zh_cn": "提交"
    },
    "common_success": {
      "en": "Success",
      "ja": "成功",
      "zh": "成功",
      "zh_cn": "成功"
    },
    "common_take_a_while": {
      "en": "It may take a while, please wait",
      "ja": "お待ちください",
      "zh": "請耐心等待",
      "zh_cn": "请耐心等待"
    },
    "common_transfer_refuse": {
      "en": "Refuse",
      "ja": "拒否する",
      "zh": "拒絕",
      "zh_cn": "拒绝"
    },
    "common_understand": {
      "en": "I have known",
      "ja": "わかりました",
      "zh": "知道了",
      "zh_cn": "知道了"
    },
    "common_use": {
      "en": "Use",
      "ja": "使う",
      "zh": "使用",
      "zh_cn": "使用"
    },
    "login_account_ban_msg": {
      "en": "Your account is seriously abnormal and has been blocked out temporarily, it will be lifted after the end of the countdown. If you have any questions,please contact us in official channels",
      "ja": "あなたのアカウントは重大な異常により一時的にブロックされていますが、カウントダウン終了後に解除されます。ご質問がある場合は、公式チャンネルでお問い合わせください",
      "zh": "您的賬戶嚴重異常，已被暫時封鎖，倒計時結束後將解除。如果您有任何疑問，請通過官方渠道聯系我們。",
      "zh_cn": "您的账户严重异常，已被暂时封锁，倒计时结束后将解除。如果您有任何疑问，请通过官方渠道联系我们。"
    },
    "login_account_ban_msg2": {
      "en": "Your account had mulity abnormal requests of registration & logout and has been banned temporarily. It will be lifted after the end of the countdown. If you have questions please contact us in Official Discord Channels",
      "ja": "あなたのアカウントは登録とログアウトの異常なリクエストが多数あったため、一時的に禁止されました。カウントダウン終了後に解除されます。ご質問がある場合は、公式 Discord チャンネルでお問い合わせください。",
      "zh": "您的賬號出現多次異常註冊、註銷請求，已被暫時封禁。倒計時結束後將解除。如果您有疑問，請通過官方 Discord 渠道聯系我們。",
      "zh_cn": "您的账号出现多次异常注册、注销请求，已被暂时封禁。倒计时结束后将解除。如果您有疑问，请通过官方 Discord 渠道联系我们。"
    },
    "login_account_err_toast": {
      "en": "Serve connection instable currently, please try again later.",
      "ja": "現在、接続が不安定です。後でもう一度お試しください。",
      "zh": "目前服務連接不穩定，請稍後重試",
      "zh_cn": "目前服务连接不稳定，请稍后重试"
    },
    "login_account_input_captcha": {
      "en": "Verification Code",
      "ja": "検証コード",
      "zh": "驗證碼",
      "zh_cn": "验证码"
    },
    "login_account_input_pwd": {
      "en": "Private Password",
      "ja": "プライベートパスワード",
      "zh": "密碼",
      "zh_cn": "密码"
    },
    "login_account_input_toast": {
      "en": "Email Address",
      "ja": "メールアドレス",
      "zh": "郵箱地址",
      "zh_cn": "邮箱地址"
    },
    "login_account_toast": {
      "en": "Verification code sending succeeded.",
      "ja": "認証コードの送信に成功しました。",
      "zh": "驗證碼發送成功",
      "zh_cn": "验证码发送成功"
    },
    "login_agree_agreement_privacy": {
      "en": "Agree to User Agreement & User Privacy",
      "ja": "ユーザー契約とプライバシーポリシー同意する",
      "zh": "同意用戶協議&隱私政策",
      "zh_cn": "同意用户协议&隐私政策"
    },
    "login_button": {
      "en": "Login",
      "ja": "ログイン",
      "zh": "登錄",
      "zh_cn": "登录"
    },
    "login_clause": {
      "en": "Registration means that you agree to Yulimeta's User Agreement & User Privacy",
      "ja": "登録は、Yulimeta のユーザー契約とプライバシーポリシーに同意することを意味します",
      "zh": "註冊即代表你同意Yulimeta的用戶協議和隱私政策",
      "zh_cn": "注册即代表你同意Yulimeta的用户协议和隐私政策"
    },
    "login_code": {
      "en": "Code",
      "ja": "コード",
      "zh": "驗證碼",
      "zh_cn": "验证码"
    },
    "login_code_err_toast": {
      "en": "Verification code does not match, please retype\nto try again.",
      "ja": "確認コードが一致しません。再入力してください\nもう一度試してみます。",
      "zh": "驗證碼錯誤，請重新輸入",
      "zh_cn": "验证码错误，请重新输入"
    },
    "login_email_error": {
      "en": "Invalid email address, please retype to try again.",
      "ja": "メール アドレスが無効です。再入力してもう一度お試しください。",
      "zh": "電子郵件地址無效，請重新輸入以重試。",
      "zh_cn": "电子邮件地址无效，请重新输入以重试。"
    },
    "login_error_verifcationcode": {
      "en": "Verifcationcode is incorrect, please try again.",
      "ja": "検証コードが間違っています。もう一度お試しください。",
      "zh": "驗證碼不正確，請重試。",
      "zh_cn": "验证码不正确，请重试。"
    },
    "login_game_about": {
      "en": "A Revolutionary Urban Treasure Social MMORPG in Metaverse",
      "ja": "メタバースの革新的な都市型宝探しソーシャル MMORPG ゲーム",
      "zh": "一款元宇宙革命性的都市尋寶社交MMORPG遊戲",
      "zh_cn": "一款元宇宙革命性的都市寻宝社交MMORPG游戏"
    },
    "login_load_about": {
      "en": "Always be aware of your surroundings. Do not use while cycling or driving",
      "ja": "常に周囲に注意してください。自転車や運転中には使用しないでください。",
      "zh": "時刻註意周圍的環境，不要在騎行或開車時玩遊戲。",
      "zh_cn": "时刻注意周围的环境，不要在骑行或开车时玩游戏。"
    },
    "login_login_failed": {
      "en": "Login failed.",
      "ja": "ログインに失敗しました。",
      "zh": "登錄失敗。",
      "zh_cn": "登录失败。"
    },
    "login_network_exception": {
      "en": "Network exception, please check the network connection!",
      "ja": "ネットワークが異常です。ネットワーク接続を確認してください。",
      "zh": "網絡異常，請檢查網絡連接！",
      "zh_cn": "网络异常，请检查网络连接！"
    },
    "login_player_login_failed": {
      "en": "Login failed! Please try again later!",
      "ja": "ログインに失敗しました！後でもう一度試してください。",
      "zh": "登錄失敗！請稍後再試！",
      "zh_cn": "登录失败！请稍后再试！"
    },
    "login_pwd": {
      "en": "Password",
      "ja": "パスワード",
      "zh": "密碼",
      "zh_cn": "密码"
    },
    "login_pwd_err_toast": {
      "en": "Current password incorrect, please re-entel",
      "ja": "現在のパスワードが間違っています。再入力してください",
      "zh": "當前密碼錯誤，請重新輸入",
      "zh_cn": "当前密码错误，请重新输入"
    },
    "login_quick_play": {
      "en": "Quick Play",
      "ja": "クイックプレイ",
      "zh": "游客模式",
      "zh_cn": "游客模式"
    },
    "login_register_about": {
      "en": "Account will be automatically registered",
      "ja": "アカウントは自動で登録されます",
      "zh": "未註冊的賬號將自動註冊",
      "zh_cn": "未注册的账号将自动注册"
    },
    "login_send_code": {
      "en": "Send code",
      "ja": "コード送信",
      "zh": "發送",
      "zh_cn": "发送"
    },
    "login_start_game": {
      "en": "Tap to Start Game\n",
      "ja": "タップしてゲームを開始",
      "zh": "點擊開始遊戲",
      "zh_cn": "点击开始游戏"
    },
    "login_successful_toast": {
      "en": "Login verification succeeded.",
      "ja": "ログイン認証に成功しました。",
      "zh": "登錄驗證成功",
      "zh_cn": "登录验证成功"
    },
    "login_title": {
      "en": "Continue with Email",
      "ja": "メールで続行",
      "zh": "郵箱登錄",
      "zh_cn": "邮箱登录"
    },
    "login_user_agreement": {
      "en": "User Agreement",
      "ja": "ユーザー契約",
      "zh": "用戶協議",
      "zh_cn": "用户协议"
    },
    "login_user_privacy": {
      "en": "User Privacy",
      "ja": "プライバシーポリシー",
      "zh": "隱私政策",
      "zh_cn": "隐私政策"
    },
    "profile_add_tag": {
      "en": "Add Tag",
      "ja": "タグを追加",
      "zh": "添加標簽",
      "zh_cn": "添加标签"
    },
    "profile_addr": {
      "en": "Signed address:",
      "ja": "ウォレット：",
      "zh": "錢包地址：",
      "zh_cn": "钱包地址："
    },
    "profile_avatar": {
      "en": "Profile photo",
      "ja": "プロフィール画像",
      "zh": "個人頭像",
      "zh_cn": "个人头像"
    },
    "profile_avatar_buy_desc": {
      "en": "The activity related to this avatar has ended. You can spend <%> to unlock this avatar.",
      "ja": "このアバターの関連イベントは終了しました。<%> を費やすと、このアバターのロックを解除できます。",
      "zh": "該頭像的相關活動已結束，您可以花費 <%>解鎖該頭像。",
      "zh_cn": "该头像的相关活动已结束，您可以花费 <%>解锁该头像。"
    },
    "profile_avatar_ended": {
      "en": "Unfortunately, the activity related to this avatar has ended.",
      "ja": "残念ながら、このアバターの関連イベントは終了しました。",
      "zh": "很遺憾，該頭像的相關活動已經結束了。",
      "zh_cn": "很遗憾，该头像的相关活动已经结束了。"
    },
    "profile_avatar_title": {
      "en": "Choose an Profile Photo",
      "ja": "プロフィール画像を選択",
      "zh": "選擇個人頭像",
      "zh_cn": "选择个人头像"
    },
    "profile_avatar_unlock": {
      "en": "Avatar is not unlocked",
      "ja": "アバターがロック解除されていません",
      "zh": "頭像未解鎖",
      "zh_cn": "头像未解锁"
    },
    "profile_avatar_unlocked_successfully": {
      "en": "Unlocked successfully",
      "ja": "ロック解除に成功しました",
      "zh": "解鎖成功",
      "zh_cn": "解锁成功"
    },
    "profile_birthdate": {
      "en": "Birthdate",
      "ja": "誕生日",
      "zh": "生日",
      "zh_cn": "生日"
    },
    "profile_captcha": {
      "en": "Verification code",
      "ja": "認証コード",
      "zh": "驗證碼",
      "zh_cn": "验证码"
    },
    "profile_change_name_content": {
      "en": "Are you sure you want to change your nickname with a [Name Change Card]?",
      "ja": "[Name Change Card]でニックネームを変更してもよろしいですか？",
      "zh": "您確定要消耗一張[Name Change Card]更改您的昵稱嗎？",
      "zh_cn": "您确定要消耗一张[Name Change Card]更改您的昵称吗？"
    },
    "profile_change_name_opps": {
      "en": "opps! Insufficient props！",
      "ja": "おっとっと！プロペが足りない！",
      "zh": "哎呀！道具不足！",
      "zh_cn": "哎呀！道具不足！"
    },
    "profile_change_name_tips": {
      "en": "Your nickname can only be changed once every 30days.\nEach change will consume a [Name Change Card].",
      "ja": "ニックネームは 30 日に 1 回のみ変更できます。\n変更ごとに[Name Change Card]が消費されます。",
      "zh": "您的昵稱每30天只能更改一次。\n每次更改都需消耗一張[Name Change Card]。",
      "zh_cn": "您的昵称每30天只能更改一次。\n每次更改都需消耗一张[Name Change Card]。"
    },
    "profile_change_name_tips_2": {
      "en": "Your nickname can only be changed once every 30 days. Please try again after the countdown ends.",
      "ja": "ニックネームは 30 日に 1 回のみ変更できます。カウントダウンが終了してからもう一度お試しください。",
      "zh": "您的昵稱每30天只能更改一次。請在倒計時結束後重試。",
      "zh_cn": "您的昵称每30天只能更改一次。请在倒计时结束后重试。"
    },
    "profile_changed_psw_success": {
      "en": "Password changed successfully",
      "ja": "パスワードの変更に成功しました",
      "zh": "密碼修改成功",
      "zh_cn": "您的账号在另一个设备登录"
    },
    "profile_clear_button": {
      "en": "clear",
      "ja": "クリア",
      "zh": "清除",
      "zh_cn": "清除"
    },
    "profile_code": {
      "en": "Code",
      "ja": "コード",
      "zh": "驗證碼",
      "zh_cn": "验证码"
    },
    "profile_confirm_pwd": {
      "en": "Confirm password",
      "ja": "パスワードを確認する",
      "zh": "確認密碼",
      "zh_cn": "确认密码"
    },
    "profile_copy_addr": {
      "en": "Address copied",
      "ja": "アドレスをコピーしました",
      "zh": "已復製地址",
      "zh_cn": "已复制地址"
    },
    "profile_copy_user_id": {
      "en": "User ID copied",
      "ja": "ユーザIDをコピーしました",
      "zh": "已復製個人ID",
      "zh_cn": "已复制个人ID"
    },
    "profile_countdown_days": {
      "en": "Days",
      "ja": "日",
      "zh": "天",
      "zh_cn": "天"
    },
    "profile_countdown_hours": {
      "en": "Hours",
      "ja": "時間",
      "zh": "小時",
      "zh_cn": "小时"
    },
    "profile_countdown_mins": {
      "en": "Mins",
      "ja": "分",
      "zh": "分鐘",
      "zh_cn": "分钟"
    },
    "profile_countdown_seconds": {
      "en": "Seconds",
      "ja": "秒",
      "zh": "秒",
      "zh_cn": "秒"
    },
    "profile_current_pwd": {
      "en": "Current password",
      "ja": "現在のパスワード",
      "zh": "當前密碼",
      "zh_cn": "当前密码"
    },
    "profile_dialog_not_browser": {
      "en": "You have not installed the application market, not even the browser",
      "ja": "アプリストアまたはブラウザがインストールされていません",
      "zh": "您沒有安裝手機應用市場或瀏覽器",
      "zh_cn": "您没有安装手机应用市场或浏览器"
    },
    "profile_dialog_update": {
      "en": "Update",
      "ja": "更新する",
      "zh": "更新",
      "zh_cn": "更新"
    },
    "profile_dialog_update_title": {
      "en": "Announcement",
      "ja": "お知らせ",
      "zh": "公告",
      "zh_cn": "公告"
    },
    "profile_edit": {
      "en": "Edit",
      "ja": "編集",
      "zh": "編輯",
      "zh_cn": "编辑"
    },
    "profile_edit_info": {
      "en": "Edit Profile",
      "ja": "プロフィール編集",
      "zh": "編輯個人資料",
      "zh_cn": "编辑个人资料"
    },
    "profile_email": {
      "en": "Email",
      "ja": "メールアドレス",
      "zh": "郵箱地址",
      "zh_cn": "邮箱地址"
    },
    "profile_email_modify_pwd": {
      "en": "To ensure the security of your account you need to verify your identity first",
      "ja": "アカウントのセキュリティを確保するには、まず本人確認を行う必要があります。",
      "zh": "為了確保您帳戶的安全，需要首先驗證您的身份",
      "zh_cn": "为了确保您帐户的安全，需要首先验证您的身份"
    },
    "profile_fail_toast": {
      "en": "Profile saving failed",
      "ja": "プロフィールの保存に失敗しました",
      "zh": "個人資料保存失敗",
      "zh_cn": "个人资料保存失败"
    },
    "profile_famale": {
      "en": "Female",
      "ja": "女",
      "zh": "女",
      "zh_cn": "女"
    },
    "profile_firstset_nickname": {
      "en": "You can modify your nickname for free for the first time. Each subsequent change will cost a [Name Change Card], and it can only be changed once within 30 days.",
      "ja": "ニックネームの変更は初回無料で行えますが、2回目以降の変更には[Name Change Card]が必要となり、30日以内に1回のみ変更可能です。",
      "zh": "首次修改昵稱可免費修改，之後每次更改都需消耗一張[改名卡]，且30天內只能更改一次。",
      "zh_cn": "首次修改昵称可免费修改，之后每次更改都需消耗一张[改名卡]，且30天内只能更改一次。"
    },
    "profile_function_limitation": {
      "en": "Function Limitation",
      "ja": "機能制限",
      "zh": "功能限製",
      "zh_cn": "功能限制"
    },
    "profile_function_limitation_content": {
      "en": "Please connect your wallet account first.The feature is not available before you connect your wallet account.\nYou can choose importing a wallet account or create a new wallet account.",
      "ja": "まずウォレット アカウントを接続してください。ウォレット アカウントを接続するまでは、この機能は利用できません。\nウォレット アカウントをインポートするか、新しいウォレット アカウントを作成するかを選択できます。",
      "zh": "請先連接您的錢包賬戶。連接錢包賬戶前，該功能不可用。\n您可以選擇導入錢包賬戶或創建新的錢包賬戶。",
      "zh_cn": "请先连接您的钱包账户。连接钱包账户前，该功能不可用。\n您可以选择导入钱包账户或创建新的钱包账户。"
    },
    "profile_gallery": {
      "en": "Yuli Gallery",
      "ja": "Yuli ギャラリー",
      "zh": "Yuli 畫廊",
      "zh_cn": "Yuli 画廊"
    },
    "profile_gender": {
      "en": "Gender",
      "ja": "性別",
      "zh": "性別",
      "zh_cn": "性别"
    },
    "profile_have_known": {
      "en": "I Have Known",
      "ja": "わかりました",
      "zh": "知道了",
      "zh_cn": "知道了"
    },
    "profile_im_add_to_starmark": {
      "en": "Add to StarMark",
      "ja": "スターマークを付ける",
      "zh": "添加到特別關註",
      "zh_cn": "添加到特别关注"
    },
    "profile_im_block_message": {
      "en": "Block Message",
      "ja": "ブロックする",
      "zh": "加入黑名單",
      "zh_cn": "加入黑名单"
    },
    "profile_im_block_msg_fails": {
      "en": "Block message Fails",
      "ja": "ブラックアウト失敗",
      "zh": "拉黑失敗",
      "zh_cn": "拉黑失败"
    },
    "profile_im_block_msg_successfully": {
      "en": "Block message successfully",
      "ja": "ブロックしました",
      "zh": "拉黑成功",
      "zh_cn": "拉黑成功"
    },
    "profile_im_cancel": {
      "en": "Cancel",
      "ja": "キャンセル",
      "zh": "取消",
      "zh_cn": "取消"
    },
    "profile_im_chat": {
      "en": "Chat",
      "ja": "チャット",
      "zh": "聊天",
      "zh_cn": "聊天"
    },
    "profile_im_clear_history": {
      "en": "Clear History",
      "ja": "チャット履歴をクリアする",
      "zh": "清除聊天記錄",
      "zh_cn": "清除聊天记录"
    },
    "profile_im_clear_history_success": {
      "en": "Clear history successfully",
      "ja": "チャット履歴をクリアしました",
      "zh": "聊天記錄清除成功",
      "zh_cn": "聊天记录清除成功"
    },
    "profile_im_confirm": {
      "en": "Confirm",
      "ja": "確認",
      "zh": "確認",
      "zh_cn": "确认"
    },
    "profile_im_content_1": {
      "en": "You cannot use camera unless your camera be authorized.",
      "ja": "カメラの使用が許可されていないため、カメラ機能が使用できません。",
      "zh": "您未授權相機的使用權限，無法使用相機功能。",
      "zh_cn": "您未授权相机的使用权限，无法使用相机功能。"
    },
    "profile_im_content_2": {
      "en": "If you clear chat history, all chat messages will be deleted and cannot be\nrecovered later.",
      "ja": "チャット履歴を消去すると、すべてのチャット メッセージが削除され、復元できなくなります。",
      "zh": "如果清除聊天記錄，所有聊天消息將被刪除且無法再被恢復。",
      "zh_cn": "如果清除聊天记录，所有聊天消息将被删除且无法再被恢复。"
    },
    "profile_im_content_3": {
      "en": "If vou block contact s message then you won't send message or receive messagefrom this contact.",
      "ja": "ブロックすると相手にメッセージを送信できなくなり、相手からのメッセージも受信できなくなります。",
      "zh": "拉黑後，你將無法發送消息給對方，也不會接收到對方給你發的消息。",
      "zh_cn": "拉黑后，你将无法发送消息给对方，也不会接收到对方给你发的消息。"
    },
    "profile_im_content_4": {
      "en": "If vou delete contact,then vou won't send message or get bonus,and the record will be deleted,too.",
      "ja": "連絡先を削除するとメッセージの送受信ができなくなり、トーク履歴も削除されます。",
      "zh": "如果您刪除了聯系人，那麽您將不能發送或接收消息，並且聊天記錄也會被刪除。",
      "zh_cn": "如果您删除了联系人，那么您将不能发送或接收消息，并且聊天记录也会被删除。"
    },
    "profile_im_days": {
      "en": "Days",
      "ja": "日",
      "zh": "天",
      "zh_cn": "天"
    },
    "profile_im_delete_contact": {
      "en": "Delete Contact",
      "ja": "連絡先を削除する",
      "zh": "刪除聯系人",
      "zh_cn": "删除联系人"
    },
    "profile_im_delete_contact_success": {
      "en": "Delete contact successfully",
      "ja": "連絡先を削除しました",
      "zh": "聯系人刪除成功",
      "zh_cn": "联系人删除成功"
    },
    "profile_im_friends": {
      "en": "Friends",
      "ja": "フレンド",
      "zh": "好友",
      "zh_cn": "好友"
    },
    "profile_im_go_install": {
      "en": "Go install",
      "ja": "許可する",
      "zh": "去授權",
      "zh_cn": "去授权"
    },
    "profile_im_messages": {
      "en": "Messages",
      "ja": "メッセージ",
      "zh": "信息",
      "zh_cn": "信息"
    },
    "profile_im_no_friends": {
      "en": "No Friends",
      "ja": "フレンドはいない",
      "zh": "沒有好友",
      "zh_cn": "没有好友"
    },
    "profile_im_no_messages": {
      "en": "No Messages",
      "ja": "メッセージはありません",
      "zh": "沒有信息",
      "zh_cn": "没有信息"
    },
    "profile_im_pin_message": {
      "en": "Pin Message",
      "ja": "ピン止めする",
      "zh": "置頂",
      "zh_cn": "置顶"
    },
    "profile_im_recent": {
      "en": "Recent",
      "ja": "\n最近",
      "zh": "剛剛",
      "zh_cn": "刚刚"
    },
    "profile_im_send": {
      "en": "Send",
      "ja": "送る",
      "zh": "發送",
      "zh_cn": "发送"
    },
    "profile_im_send_message": {
      "en": "Send Message",
      "ja": "メッセージを送る",
      "zh": "發送消息",
      "zh_cn": "发送消息"
    },
    "profile_im_sure_to_block": {
      "en": "Sure To Block?",
      "ja": "ブロックしますか?",
      "zh": "確定拉黑嗎?",
      "zh_cn": "确定拉黑吗?"
    },
    "profile_im_sure_to_clear": {
      "en": "Sure To Clear?",
      "ja": "本当にクリアしますか?",
      "zh": "確定清除嗎？",
      "zh_cn": "确定清除吗？"
    },
    "profile_im_sure_to_delete": {
      "en": "Sure To Delete?",
      "ja": "削除してもよろしいですか?",
      "zh": "確認刪除嗎？",
      "zh_cn": "确认删除吗？"
    },
    "profile_im_type_a_message": {
      "en": "Type a message",
      "ja": "本文を入力してください",
      "zh": "請輸入文字",
      "zh_cn": "请输入文字"
    },
    "profile_im_unblock": {
      "en": "Unblock",
      "ja": "ブロックを解除する",
      "zh": "解除拉黑",
      "zh_cn": "解除拉黑"
    },
    "profile_im_unmute_message": {
      "en": "Unmute Message",
      "ja": "ミュートを解除する",
      "zh": "消息取消靜音",
      "zh_cn": "消息取消静音"
    },
    "profile_login_another": {
      "en": "Your account is logged in on another device",
      "ja": "あなたのアカウントは別のデバイスでログインしています",
      "zh": "您的賬號在另一個設備登錄",
      "zh_cn": "您的账号在另一个设备登录"
    },
    "profile_login_button": {
      "en": "Save and Re Login",
      "ja": "保存して再度ログインします",
      "zh": "保存並重新登錄",
      "zh_cn": "保存并重新登录"
    },
    "profile_male": {
      "en": "Male",
      "ja": "男",
      "zh": "男",
      "zh_cn": "男"
    },
    "profile_modify_nickname": {
      "en": "Change Nickname",
      "ja": "ニックネームを変更する",
      "zh": "修改昵稱",
      "zh_cn": "修改昵称"
    },
    "profile_modify_pwd": {
      "en": "Change password",
      "ja": "パスワードを変更する",
      "zh": "修改密碼",
      "zh_cn": "修改密码"
    },
    "profile_name_cost": {
      "en": "Cost:",
      "ja": "コスト：",
      "zh": "消耗：",
      "zh_cn": "消耗："
    },
    "profile_new_pwd": {
      "en": "New password",
      "ja": "新しいパスワード",
      "zh": "新密碼",
      "zh_cn": "新密码"
    },
    "profile_new_pwd_about": {
      "en": "Please input your new password .You are able to  change them later",
      "ja": "新しいパスワードを入力してください。後で変更することもできます。",
      "zh": "請輸入您的新密碼。您在之後也可以更改它們",
      "zh_cn": "请输入您的新密码。您在之后也可以更改它们"
    },
    "profile_nickname": {
      "en": "Nickname",
      "ja": "ニックネーム",
      "zh": "昵稱",
      "zh_cn": "昵称"
    },
    "profile_not_enough_card": {
      "en": "You do not have enough\n[Name Change Card].",
      "ja": "[Name Change Card]が足りません。",
      "zh": "你沒有足夠的\n[Name Change Card] ",
      "zh_cn": "你没有足够的\n[Name Change Card] "
    },
    "profile_old_pwd": {
      "en": "Old password",
      "ja": "現在のパスワード",
      "zh": "舊密碼",
      "zh_cn": "旧密码"
    },
    "profile_owned": {
      "en": "Current Owned:",
      "ja": "所有数：",
      "zh": "當前持有：",
      "zh_cn": "当前持有："
    },
    "profile_personal_profile": {
      "en": "Profile",
      "ja": "プロフィール",
      "zh": "簡介",
      "zh_cn": "简介"
    },
    "profile_pwd": {
      "en": "Password",
      "ja": "パスワード",
      "zh": "密碼",
      "zh_cn": "密码"
    },
    "profile_pwd_incorrect": {
      "en": "Current password incorrect please re-enter!",
      "ja": "現在のパスワードは間違っています。再入力してください。",
      "zh": "當前密碼不正確，請重新輸入！",
      "zh_cn": "当前密码不正确，请重新输入！"
    },
    "profile_pwd_not_match": {
      "en": "Passwords does not match, please re-enter!",
      "ja": "パスワードが一致しません。再入力してください。",
      "zh": "密碼不正確，請重新輸入！",
      "zh_cn": "密码不正确，请重新输入！"
    },
    "profile_set_nickname": {
      "en": "Set your nickname",
      "ja": "ニックネームを設定する",
      "zh": "設置你的昵稱",
      "zh_cn": "设置你的昵称"
    },
    "profile_set_nickname_empty": {
      "en": "Input box cannot be empty",
      "ja": "入力ボックスは空欄にできません",
      "zh": "輸入框不能為空",
      "zh_cn": "输入框不能为空"
    },
    "profile_set_nickname_limit": {
      "en": "The length cannot exceed 15 digits",
      "ja": "15文字以内",
      "zh": "長度不超過15個字符",
      "zh_cn": "长度不超过15个字符"
    },
    "profile_set_psw_success": {
      "en": "Password set successfully",
      "ja": "パスワードの設定に成功しました",
      "zh": "密碼設置成功",
      "zh_cn": "密码设置成功"
    },
    "profile_set_pwd": {
      "en": "Set your password",
      "ja": "パスワードを設定する",
      "zh": "設置您的密碼",
      "zh_cn": "设置您的密码"
    },
    "profile_set_pwd_about": {
      "en": "Use 8 or more characters with a mix of upper case, lower case & numbers",
      "ja": "8文字以上、大文字、小文字、数字を混合",
      "zh": "使用8個或更多字符，並混合使用大寫、小寫和數字",
      "zh_cn": "使用8个或更多字符，并混合使用大写、小写和数字"
    },
    "profile_sure_to_change": {
      "en": "Sure to Change?",
      "ja": "本当に変更しますか?",
      "zh": "確定修改嗎？",
      "zh_cn": "确定修改吗？"
    },
    "profile_tag_about": {
      "en": "list to show your web3 prefer",
      "ja": "好きなweb3を掲示しましょう",
      "zh": "添加標簽以展示您的web3愛好",
      "zh_cn": "添加标签以展示您的web3爱好"
    },
    "profile_toast": {
      "en": "Profile saving succeeded",
      "ja": "プロフィールの保存に成功しました",
      "zh": "個人資料保存成功",
      "zh_cn": "个人资料保存成功"
    },
    "profile_unable_to_change": {
      "en": "Unable to change Nickname!",
      "ja": "ニックネームが変更できない！",
      "zh": "無法更改昵稱！",
      "zh_cn": "无法更改昵称！"
    },
    "register_continue_button": {
      "en": "Continue",
      "ja": "続く",
      "zh": "繼續",
      "zh_cn": "继续"
    },
    "register_file_button": {
      "en": "Register File",
      "ja": "登録書類",
      "zh": "註冊文件",
      "zh_cn": "注册文件"
    },
    "register_nickname": {
      "en": "Set your nickname",
      "ja": "ニックネームを設定する",
      "zh": "設置你的昵稱",
      "zh_cn": "设置你的昵称"
    },
    "register_robot_dialogue3": {
      "en": "Now we start our tour together!I will lead you to complete several tasks first!\nAfter you have gotten ready to start, please check the tasks first!",
      "ja": "さあ、一緒にツアーを始めましょう! 最初にいくつかのタスクを完了するようご案内します!\n始める準備ができたら、まずはタスクを確認してください！",
      "zh": "現在一起開始我們的旅行吧！我將帶領您先完成幾個任務！\n當你準備好之後開始，請先查看任務！",
      "zh_cn": "现在一起开始我们的旅行吧！我将带领您先完成几个任务！\n当你准备好之后开始，请先查看任务！"
    },
    "register_submit_button": {
      "en": "Submit",
      "ja": "申し出る",
      "zh": "提交",
      "zh_cn": "提交"
    },
    "register_title": {
      "en": "Registration Form",
      "ja": "登録用紙",
      "zh": "註冊表單",
      "zh_cn": "注册表单"
    },
    "register_title2": {
      "en": "Registrant:",
      "ja": "登録者:",
      "zh": "註冊人：",
      "zh_cn": "注册人："
    },
    "register_toast": {
      "en": "I'm willing to join Project Katharsis and set off to end chaos in the world of humancivilization AD 2022.",
      "ja": "私はプロジェクト カタルシスに参加し、西暦 2022 年の人類文明の世界の混乱を終わらせるために出発します。",
      "zh": "我願意加入Katharsis計劃，出發去結束公元 2022 年人類文明世界的混亂。",
      "zh_cn": "我愿意加入Katharsis计划，出发去结束公元 2022 年人类文明世界的混乱。"
    },
    "role_continue_button": {
      "en": "Continue",
      "ja": "続く",
      "zh": "繼續",
      "zh_cn": "继续"
    },
    "role_guide_about": {
      "en": "You can unlock both of them soon after",
      "ja": "すぐに両方のロックを解除できます",
      "zh": "你在之後都可以解鎖所有的向導",
      "zh_cn": "你在之后都可以解锁所有的向导"
    },
    "role_guide_title": {
      "en": "Choose Your Guide",
      "ja": "ガイドを選択してください",
      "zh": "選擇你的向導",
      "zh_cn": "选择你的向导"
    },
    "settings_checking": {
      "en": "checking...",
      "ja": "チェック中...",
      "zh": "檢查中",
      "zh_cn": "检查中"
    },
    "settings_community": {
      "en": "Contact",
      "ja": "連絡",
      "zh": "聯係",
      "zh_cn": "联系"
    },
    "settings_del_account": {
      "en": "Delete Account",
      "ja": "アカウントを削除する",
      "zh": "刪除賬號",
      "zh_cn": "删除账号"
    },
    "settings_del_account_button": {
      "en": "Delete my account",
      "ja": "アカウントを削除します",
      "zh": "刪除我的賬號",
      "zh_cn": "删除我的账号"
    },
    "settings_del_account_content1": {
      "en": "If you are sure that you want to delete your Yulimeta account, you should be noticed that:",
      "ja": "Yulimeta アカウントを本当に削除する場合は、次の点に注意してください：",
      "zh": "如果您確定要刪除您的 Yulimeta 帳戶，您應該註意：",
      "zh_cn": "如果您确定要删除您的 Yulimeta 帐户，您应该注意："
    },
    "settings_del_account_content2": {
      "en": "① When your account is deleted, you will be logged out of Yulimeta, and you may log in with this email account again with no more previous data.\n② When your account is deleted, your wallet account will be free to import to another email account with no more previous data.\n③ If you delete your account,the game data and user data will be permanently deleted, including your profiles, your cards, your messages and your friends, etc, which means that you will not be able to find these data back agai",
      "ja": "①削除後はYulimetaからログアウトされ、同じメールアカウントで再度ログインしても以前のデータは残っておりません。\n②アカウントが削除されると、ウォレットアカウントは別のメールアカウントに自由にインポートできるようになりますが、以前のデータはなくなります。\n③ アカウントを削除すると、個人データ、カード、メッセージ、友達などを含むゲームデータとユーザーデータが完全に削除され、これらのデータを復元することはできなくなります。",
      "zh": "① 當您的帳戶被刪除時，您將退出Yulimeta，您可以使用該電子郵件帳戶再次登錄，但不再有以前的數據。\n② 當您的帳戶被刪除時，您的錢包帳戶將可以自由導入到另一個電子郵件帳戶，並且不再有以前的數據。\n③ 如果您刪除帳戶，遊戲數據和用戶數據將被永久刪除，包括您的個人資料、卡牌、消息和好友等，這意味著您將無法再找回這些數據。",
      "zh_cn": "① 当您的帐户被删除时，您将退出Yulimeta，您可以使用该电子邮件帐户再次登录，但不再有以前的数据。\n② 当您的帐户被删除时，您的钱包帐户将可以自由导入到另一个电子邮件帐户，并且不再有以前的数据。\n③ 如果您删除帐户，游戏数据和用户数据将被永久删除，包括您的个人资料、卡牌、消息和好友等，这意味着您将无法再找回这些数据。"
    },
    "settings_del_account_page": {
      "en": "Delete Account",
      "ja": "アカウントを削除する",
      "zh": "刪除賬號",
      "zh_cn": "删除账号"
    },
    "settings_del_account_tips": {
      "en": "Make your decision after careful consideration.",
      "ja": "慎重にご検討の上、ご決定ください。",
      "zh": "請謹慎考慮後做出決定。",
      "zh_cn": "请谨慎考虑后做出决定。"
    },
    "settings_del_account_title": {
      "en": "Are you sure to delete account?",
      "ja": "アカウントを削除してもよろしいですか?",
      "zh": "您確定要刪除帳戶嗎？",
      "zh_cn": "您确定要删除帐户吗？"
    },
    "settings_del_code_empty": {
      "en": "The code cannot be empty",
      "ja": "認証コードを入力する必要があります",
      "zh": "驗證碼不能為空",
      "zh_cn": "验证码不能为空"
    },
    "settings_del_code_incorrect": {
      "en": "The number of code is incorrect",
      "ja": "認証コードエラー",
      "zh": "驗證碼錯誤",
      "zh_cn": "验证码错误"
    },
    "settings_del_successfuly": {
      "en": "Successfully deleted",
      "ja": "削除されました",
      "zh": "刪除成功",
      "zh_cn": "删除成功"
    },
    "settings_discord": {
      "en": "Join us@Discord",
      "ja": "Discordに参加する",
      "zh": "加入我們@Discord",
      "zh_cn": "加入我们@Discord"
    },
    "settings_email_captcha": {
      "en": "Email Verification code",
      "ja": "メール認証コード",
      "zh": "郵箱驗證碼",
      "zh_cn": "邮箱验证码"
    },
    "settings_email_send_toast": {
      "en": "Sending verification code succeeded.",
      "ja": "認証コードの送信に成功しました。",
      "zh": "驗證碼發送成功",
      "zh_cn": "验证码发送成功"
    },
    "settings_exit_log_out_toast": {
      "en": "If you log out, your local data will be cleaned, which means that you need to import your wallet address and set your wallet passcode again.If you wanna use another device to play Yulimeta, you should notice that you need to bound your correct wallet address.",
      "ja": "ログアウトすると、ローカル データは消去されます。つまり、再度ウォレットアドレスをインポートしパスコードを設定する必要があります。他のデバイスを使用して Yulimeta をプレイしたい場合は、正しいウォレット アドレスを紐づけする必要があることに注意してください。",
      "zh": "如果退出，您的本地數據將被清除，這意味著您需要導入錢包地址並重新設置錢包密碼。如果您想使用其他設備玩Yulimeta，請註意您需要綁定正確的錢包地址。",
      "zh_cn": "如果退出，您的本地数据将被清除，这意味着您需要导入钱包地址并重新设置钱包密码。如果您想使用其他设备玩Yulimeta，请注意您需要绑定正确的钱包地址。"
    },
    "settings_feedback": {
      "en": "Feedback to us",
      "ja": "フィードバック",
      "zh": "向我們反饋",
      "zh_cn": "向我们反馈"
    },
    "settings_invalid_captcha": {
      "en": "Invalid captcha",
      "ja": "無効入力",
      "zh": "無效輸入",
      "zh_cn": "无效输入"
    },
    "settings_lang": {
      "en": "Language",
      "ja": "言語",
      "zh": "語言",
      "zh_cn": "语言"
    },
    "settings_language_tip": {
      "en": "You may back to home after switching language.",
      "ja": "言語を切り替えるとホームページに戻ります",
      "zh": "切換語言後你將會返回至首頁",
      "zh_cn": "切换语言后你将会返回至首页"
    },
    "settings_language_title": {
      "en": "Language",
      "ja": "言語",
      "zh": "語言",
      "zh_cn": "语言"
    },
    "settings_latency": {
      "en": "Latency：",
      "ja": "レイテンシー",
      "zh": "延遲：",
      "zh_cn": "延迟："
    },
    "settings_log_out": {
      "en": "Log out",
      "ja": "ログアウト",
      "zh": "退出登錄",
      "zh_cn": "退出登录"
    },
    "settings_off": {
      "en": "off",
      "ja": "オフ",
      "zh": "關",
      "zh_cn": "关"
    },
    "settings_on": {
      "en": "on",
      "ja": "オン",
      "zh": "開",
      "zh_cn": "开"
    },
    "settings_options": {
      "en": "Options",
      "ja": "オプション",
      "zh": "選項",
      "zh_cn": "选项"
    },
    "settings_privacy_policy": {
      "en": "Privacy policy",
      "ja": "プライバシーポリシー",
      "zh": "隱私政策",
      "zh_cn": "隐私政策"
    },
    "settings_rpc_switch": {
      "en": "RPC Switch",
      "ja": "RPCスイッチ",
      "zh": "切換RPC",
      "zh_cn": "切换RPC"
    },
    "settings_send_code": {
      "en": "Send code",
      "ja": "コード送信",
      "zh": "發送驗證碼",
      "zh_cn": "发送验证码"
    },
    "settings_submit_fail": {
      "en": "Submission Failed",
      "ja": "コミットに失敗しました",
      "zh": "提交失敗",
      "zh_cn": "提交失败"
    },
    "settings_submit_successfully": {
      "en": "Submit successfully",
      "ja": "コミットに成功しました",
      "zh": "提交成功",
      "zh_cn": "提交成功"
    },
    "settings_sure_to_del": {
      "en": "Sure to delete",
      "ja": "削除を確認する",
      "zh": "確認刪除",
      "zh_cn": "确认删除"
    },
    "settings_sure_to_log_out": {
      "en": "Sure To Log Out?",
      "ja": "ログアウトしてもよろしいですか?",
      "zh": "確定退出登錄？",
      "zh_cn": "确定退出登录？"
    },
    "settings_switch": {
      "en": "Switch",
      "ja": "スイッチ",
      "zh": "切換",
      "zh_cn": "切换"
    },
    "settings_title": {
      "en": "Settings",
      "ja": "設定",
      "zh": "設置",
      "zh_cn": "设置"
    },
    "settings_twitter": {
      "en": "Follow us@Twitter",
      "ja": "Twitterフォロー",
      "zh": "關註我們@Twitter",
      "zh_cn": "关注我们@Twitter"
    },
    "settings_user_terms": {
      "en": "Terms of user",
      "ja": "ユーザー規約",
      "zh": "用戶協議",
      "zh_cn": "用户协议"
    },
    "settings_version": {
      "en": "Ver.Public",
      "ja": "バージョン・リリース",
      "zh": "版本·發布版",
      "zh_cn": "版本·发布版"
    },
    "story_dialogue1": {
      "en": "Warp gate？",
      "ja": "ワープゲート？",
      "zh": "時空門？",
      "zh_cn": "时空门？"
    },
    "story_dialogue2": {
      "en": "Saviour？",
      "ja": "救世主？",
      "zh": "救星嗎？",
      "zh_cn": "救星吗？"
    },
    "story_dialogue3": {
      "en": "This world isdestined tobe destroyedand restart.",
      "ja": "この世界は破壊され、再び生まれ変わる運命にある。",
      "zh": "這個世界註定毀掉了，只能重新開始。",
      "zh_cn": "这个世界注定毁掉了，只能重新开始。"
    },
    "story_dialogue4": {
      "en": "WHIRR！！",
      "ja": "ヒューヒュー！！",
      "zh": "吸！！",
      "zh_cn": "吸！！"
    },
    "story_dialogue5": {
      "en": "BOOM！！",
      "ja": "ブーム！！",
      "zh": "轟！！",
      "zh_cn": "轰！！"
    },
    "story_voiceover1": {
      "en": "Old order has collapsedbut it's not Finality",
      "ja": "古い秩序は崩壊したが、ファイナリティではない",
      "zh": "舊的秩序已經崩壞，但並不是終結",
      "zh_cn": "旧的秩序已经崩坏，但并不是终结"
    },
    "story_voiceover2": {
      "en": "New order begins，while Eternal remains",
      "ja": "永遠が残る間に新たな秩序が始まる",
      "zh": "新的秩序即將開始，永恒將繼續",
      "zh_cn": "新的秩序即将开始，永恒将继续"
    },
    "tag_add_about": {
      "en": "You already add 9 tags, unable to add more.",
      "ja": "9個タグがあり、追加できません。",
      "zh": "您已經添加了9個標記，無法添加更多標記。",
      "zh_cn": "您已经添加了9个标记，无法添加更多标记。"
    },
    "tag_add_button": {
      "en": "Add Tag",
      "ja": "タグを追加する",
      "zh": "添加標簽",
      "zh_cn": "添加标签"
    },
    "tag_clear": {
      "en": "Clear",
      "ja": "クリア",
      "zh": "清除",
      "zh_cn": "清除"
    },
    "tag_content_not_blank": {
      "en": "The content can not be blank",
      "ja": "内容を空白にすることはできません",
      "zh": "內容不能為空",
      "zh_cn": "内容不能为空"
    },
    "tag_contract_about": {
      "en": "Import Contract Address",
      "ja": "コントラクトアドレスの入力",
      "zh": "輸入合約地址",
      "zh_cn": "输入合约地址"
    },
    "tag_fetch": {
      "en": "Fetch Tag : ",
      "ja": "タグを読み込む",
      "zh": "提取標簽：",
      "zh_cn": "提取标签："
    },
    "tag_fetch_error_msg": {
      "en": "No Fetch Tag, please input correct address",
      "ja": "読み込めるタグがありません。正しいアドレスを入力してください。",
      "zh": "沒有可提取標簽，請輸入正確的地址",
      "zh_cn": "没有可提取标签，请输入正确的地址"
    },
    "tag_fetch_msg": {
      "en": "No Fetch Tag Now",
      "ja": "現在タグの読み込みをしていません",
      "zh": "現在沒有提取標簽",
      "zh_cn": "现在没有提取标签"
    },
    "tag_import_button": {
      "en": "Import Address to Add Tag",
      "ja": "アドレスをインポートしてタグを追加する",
      "zh": "導入要添加標簽的地址",
      "zh_cn": "导入要添加标签的地址"
    },
    "tag_leave_button": {
      "en": "Leave now",
      "ja": "保存せず離れる",
      "zh": "現在離開",
      "zh_cn": "现在离开"
    },
    "tag_leave_now": {
      "en": "Sure To Leave Now?",
      "ja": "ページを離れますか？",
      "zh": "確定要現在離開嗎？",
      "zh_cn": "确定要现在离开吗？"
    },
    "tag_nft_addr_toast": {
      "en": "please input a NFT Contract Address",
      "ja": "NFTのコントラクトアドレスを入力してください。",
      "zh": "請輸入一個NFT合約地址",
      "zh_cn": "请输入一个NFT合约地址"
    },
    "tag_save_button": {
      "en": "Save tags",
      "ja": "保存",
      "zh": "保存標簽",
      "zh_cn": "保存标签"
    },
    "tag_save_edited": {
      "en": "You haven`t saved your tag yet do you want to save tags as you just edited?",
      "ja": "まだタグを保存していません。編集内容を保存しますか？",
      "zh": "您尚未保存標簽，是否保存剛剛編輯的標簽？",
      "zh_cn": "您尚未保存标签，是否保存刚刚编辑的标签？"
    },
    "tag_unable_to_add ": {
      "en": "Unable to Add Duplicate Tag",
      "ja": "重複したタグは追加できません",
      "zh": "無法添加重復標記",
      "zh_cn": "无法添加重复标记"
    },
    "version": 191,
    "yuli_image_dialog_choose_yuli": {
      "en": "Choose Yuli",
      "ja": "Yuliを選択してください",
      "zh": "選擇Yuli",
      "zh_cn": "选择Yuli"
    },
    "yuli_image_dialog_sanity": {
      "en": "Sanity",
      "ja": "精神力",
      "zh": "精神力",
      "zh_cn": "精神力"
    },
    "yuli_image_gallery_about": {
      "en": "Press and slide to change the order",
      "ja": "押したままドラッグして並べ替えます",
      "zh": "按住拖動可調整順序",
      "zh_cn": "按住拖动可调整顺序"
    },
    "yuli_image_gallery_title": {
      "en": "Yuli Gallery",
      "ja": "Yuli ギャラリー",
      "zh": "Yuli 畫廊",
      "zh_cn": "Yuli画廊"
    },
    "yuli_image_property_about": {
      "en": "Yuli in gallery will show on your social card Only 5 Yuli can be chosen, show in your custom order",
      "ja": "ギャラリーのYuliがあなたのソーシャルカードに登場します。Yuliは5体まで選択可能で、順番に表示されます。",
      "zh": "畫廊裏的Yuli將出現在你的社交卡片上。只能選擇5個Yuli，Yuli將按你的自定義順序顯示",
      "zh_cn": "画廊里的Yuli将出现在你的社交卡片上。只能选择5个Yuli，Yuli将按你的自定义顺序显示"
    },
    "yuli_image_select_button": {
      "en": "choose yuli",
      "ja": "Yuliを選択",
      "zh": "選擇Yuli",
      "zh_cn": "选择Yuli"
    }
  }